import React, { useState } from "react";
import { confirmSignUp, resendSignUpCode } from '@aws-amplify/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import toastr from "toastr"; // Import Toastr
const ConfirmEmailPage = () => {
    const [confirmationCode, setConfirmationCode] = useState("");
    const [isResending, setIsResending] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    // Get email from location state (passed during registration)
    const email = location.state?.email;

    const handleConfirm = async (e) => {
        e.preventDefault();

        if (!confirmationCode) {
            toastr.error("Confirmation code is required");
            return;
        }

        try {
            await confirmSignUp({
                username: email,
                confirmationCode,
            });

            // Retrieve organizationID from the state passed via navigate
            const { state } = location;
            const organizationID = state?.organizationID;

            // Save organizationID to localStorage
            if (organizationID) {
                localStorage.setItem("organizationID", organizationID);
            }

            toastr.success("Confirmation successful! You can now log in.");
            navigate("/login"); // Redirect to the login page
        } catch (error) {
            console.error("Error confirming sign-up:", error);
            toastr.error(error.message || "Something went wrong during confirmation.");
        }
    };
    const handleResendCode = async () => {
        if (!email) {
            toastr.error("Email is not available.");
            return;
        }
        console.log(email);

        setIsResending(true); // Set state to show loading indicator

        try {
            await resendSignUpCode({
                username: email
            });
            toastr.success("A new confirmation code has been sent to your email.");
        } catch (error) {
            console.error("Error resending confirmation code:", error);
            toastr.error(error.message || "Failed to resend confirmation code.");
        } finally {
            setIsResending(false); // Reset loading state
        }
    };
    return (
        <div className="container d-flex justify-content-center align-items-center vh-100">
            <div className="col-md-4 p-4 bg-white shadow rounded">
                <h3 className="mb-4 text-center">Confirm Your Email</h3>
                <form onSubmit={handleConfirm}>
                    <div className="mb-3">
                        <label htmlFor="confirmationCode" className="form-label">Confirmation Code</label>
                        <input
                            type="text"
                            id="confirmationCode"
                            className="form-control"
                            value={confirmationCode}
                            onChange={(e) => setConfirmationCode(e.target.value)}
                            placeholder="Enter your confirmation code"
                            required
                        />
                    </div>
                    <button type="submit" className="btn w-100" style={{ backgroundColor: "#342ead", color: "#fff" }}>Confirm</button>
                </form>
                <p className="mt-3 text-center">
                    <small>
                        Didn't receive a code?{" "}
                        <button
                            type="button"
                            className="btn btn-link p-0"
                            style={{ color: "#342ead" }}
                            onClick={handleResendCode}
                            disabled={isResending}
                        >
                            {isResending ? "Resending..." : "Resend"}
                        </button>
                    </small>
                </p>
            </div>
        </div>
    );
};

export default ConfirmEmailPage;
